/*
 * @Author: your name
 * @Date: 2020-12-03 16:42:31
 * @LastEditTime: 2020-12-09 14:30:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\main.js
 */
// import "babel-polyfill";
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import moment from 'moment';
import lodash from 'lodash';
import router from './route/router';
import CONFIG from './common/config';
import * as DBMODEL from './utils/dbmodel';
import { GLOBAL } from './common/global.func';

import ResetButton from './components/ResetButton.vue';
import GobackButton from './components/GobackButton.vue';
import PageInfo from './components/PageInfo.vue';
import { Alert,Layout,Result,Spin,Drawer,Timeline ,Empty,Tabs,Steps,Tooltip, Button,Upload,Popover,Row,Col,Switch,FormModel,Dropdown,TreeSelect,List, Icon, Menu, Breadcrumb,Tag, Form, Input, Select, Checkbox, DatePicker, ConfigProvider, Radio, message, Modal, Table, Popconfirm, Affix, Card, InputNumber, Pagination ,Divider,Tree,Statistic,TimePicker,Progress,Descriptions,Badge} from 'ant-design-vue';
import './common/common.less';
import echarts from 'echarts';
import {fplogger} from './common/fplogger'


Vue.config.productionTip = false

/* 定义Vue全局变量 */
Vue.prototype.G = GLOBAL    //项目中的全局方法
Vue.prototype.C = CONFIG    //项目中的相关配置项
Vue.prototype.D = DBMODEL   //数据CURD操作的模型(axios请求)
Vue.prototype.moment = moment
Vue.prototype.lodash = lodash
Vue.prototype.message = message
Vue.prototype.loading = store.state.loading   //把this.loading 映射为 this.loading.state(简写/别名)
Vue.prototype.$echarts = echarts;
Vue.prototype.FG = fplogger;
Vue.prototype.$success = Modal.success;
Vue.prototype.$confirm = Modal.confirm;


/* 使用Vue全局插件 */
Vue.use(Alert)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Icon)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Switch)
Vue.use(Affix)
Vue.use(Input)
Vue.use(Modal)
Vue.use(Radio)
Vue.use(Table)
Vue.use(Button)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(Pagination)
Vue.use(Popconfirm)
Vue.use(DatePicker)
Vue.use(Breadcrumb)
Vue.use(InputNumber)
Vue.use(ConfigProvider)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(List)
Vue.use(Dropdown)
Vue.use(TreeSelect)
Vue.use(Tree)
Vue.use(Upload)
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(Statistic)
Vue.use(Tooltip)
Vue.use(Steps)
Vue.use(Empty)
Vue.use(Drawer)
Vue.use(Spin)
Vue.use(TimePicker)
Vue.use(Timeline)
Vue.use(Progress)
Vue.use(Result)
Vue.use(Descriptions)
Vue.use(Badge)


/* 注册全局组件 */
Vue.component('v-pageinfo', PageInfo) //分页
Vue.component('v-resetbutton', ResetButton) //重置按钮, 把当前页面展示的内容 初始化到 页面刚进来时候你所看到的效果
Vue.component('v-gobackbutton', GobackButton) //返回按钮

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
